export const approvalTemplates = [
  {
    id: "tmpl1",
    type: "contract",
    title: "전속 계약서",
    icon: "ri-file-paper-2-line",
    description: "아티스트와의 전속 계약 체결 양식",
    fields: [
      { id: "f1", label: "계약 아티스트명", type: "text", placeholder: "예: 루나&스타즈", required: true },
      { id: "f2", label: "계약 기간 (시작)", type: "date", required: true },
      { id: "f3", label: "계약 기간 (종료)", type: "date", required: true },
      { id: "f4", label: "전속 계약금 (만원)", type: "number", placeholder: "예: 2000", required: true },
      { id: "f5", label: "수익 배분율 - 회사 (%)", type: "number", placeholder: "예: 60", required: true },
      { id: "f6", label: "수익 배분율 - 아티스트 (%)", type: "number", placeholder: "예: 40", required: true },
      { id: "f7", label: "전담 매니저", type: "text", placeholder: "담당 매니저 이름", required: false },
      { id: "f8", label: "특약 사항", type: "textarea", placeholder: "추가 계약 조건을 입력하세요.", required: false },
    ],
  },
  {
    id: "tmpl2",
    type: "budget",
    title: "프로젝트 예산 기안서",
    icon: "ri-money-dollar-circle-line",
    description: "프로젝트별 예산 집행 승인 요청",
    fields: [
      { id: "f1", label: "프로젝트명", type: "text", placeholder: "예: DarkNova MV 제작", required: true },
      { id: "f2", label: "총 예산 (만원)", type: "number", placeholder: "예: 8000", required: true },
      { id: "f3", label: "집행 항목", type: "text", placeholder: "예: 촬영 장비 렌탈, 감독비, 편집비", required: true },
      { id: "f4", label: "집행 예정일", type: "date", required: true },
      { id: "f5", label: "기대 효과", type: "textarea", placeholder: "이 예산 집행으로 기대되는 결과를 적어주세요.", required: true },
      { id: "f6", label: "담당 부서", type: "select", options: ["A&R부", "마케팅부", "제작부", "재무부", "법무부"], required: true },
    ],
  },
  {
    id: "tmpl3",
    type: "release",
    title: "음원 발매 기안서",
    icon: "ri-music-2-line",
    description: "앨범/싱글 발매 공식 승인 요청",
    fields: [
      { id: "f1", label: "발매 아티스트", type: "text", placeholder: "예: 루나&스타즈", required: true },
      { id: "f2", label: "앨범/싱글 제목", type: "text", placeholder: "예: Starlight EP", required: true },
      { id: "f3", label: "트랙 수", type: "number", placeholder: "예: 6", required: true },
      { id: "f4", label: "발매 예정일", type: "date", required: true },
      { id: "f5", label: "주요 유통 플랫폼", type: "text", placeholder: "예: 멜론, 스포티파이, 애플뮤직", required: true },
      { id: "f6", label: "마케팅 예산 (만원)", type: "number", placeholder: "예: 3000", required: true },
      { id: "f7", label: "앨범 콘셉트 요약", type: "textarea", placeholder: "앨범의 주제, 타깃, 분위기를 설명하세요.", required: true },
    ],
  },
  {
    id: "tmpl4",
    type: "legal",
    title: "법적 대응 기안서",
    icon: "ri-scales-3-line",
    description: "외부 법적 분쟁 대응 승인 요청",
    fields: [
      { id: "f1", label: "사안 제목", type: "text", placeholder: "예: 스타라이트엔터 표절 시비 대응", required: true },
      { id: "f2", label: "상대방 (회사/개인)", type: "text", placeholder: "예: 스타라이트 엔터테인먼트", required: true },
      { id: "f3", label: "사안 발생일", type: "date", required: true },
      { id: "f4", label: "대응 방향", type: "select", options: ["합의 협상", "법적 반박문 발송", "법적 소송 제기", "침묵 대응"], required: true },
      { id: "f5", label: "예상 법률 비용 (만원)", type: "number", placeholder: "예: 500", required: true },
      { id: "f6", label: "사안 상세 설명", type: "textarea", placeholder: "분쟁 내용과 우리 측 입장을 상세히 서술하세요.", required: true },
    ],
  },
];

// ── 추가 템플릿 (허브 연동용) ─────────────────────────────
const extraTemplates = [
  {
    id: "tmpl5",
    type: "release",
    title: "앨범 기획서 제출",
    icon: "ri-album-line",
    description: "신규 앨범/EP 기획안 공식 승인 요청",
    fields: [
      { id: "f1", label: "아티스트명", type: "text", placeholder: "예: 루나&스타즈", required: true },
      { id: "f2", label: "앨범 유형", type: "select", options: ["정규", "미니앨범(EP)", "싱글", "OST"], required: true },
      { id: "f3", label: "앨범 제목 (가제)", type: "text", placeholder: "예: Starlight Vol.2", required: true },
      { id: "f4", label: "예상 트랙 수", type: "number", placeholder: "예: 6", required: true },
      { id: "f5", label: "발매 예정일", type: "date", required: true },
      { id: "f6", label: "제작 예산 (만원)", type: "number", placeholder: "예: 8000", required: true },
      { id: "f7", label: "타겟 오디언스", type: "text", placeholder: "예: 15~28세 K-POP 팬덤, 국내외", required: true },
      { id: "f8", label: "콘셉트 방향성", type: "textarea", placeholder: "앨범 세계관, 비주얼 방향, 장르 설명", required: true },
    ],
  },
  {
    id: "tmpl6",
    type: "budget",
    title: "공연 운영 계획서",
    icon: "ri-mic-line",
    description: "공연 전체 운영 계획 승인 요청",
    fields: [
      { id: "f1", label: "공연명", type: "text", placeholder: "예: K-ArtPEN 썸머 페스티벌 2026", required: true },
      { id: "f2", label: "공연 일정", type: "date", required: true },
      { id: "f3", label: "공연장", type: "text", placeholder: "예: 올림픽 체조경기장", required: true },
      { id: "f4", label: "예상 관객 수", type: "number", placeholder: "예: 7000", required: true },
      { id: "f5", label: "총 예산 (만원)", type: "number", placeholder: "예: 71000", required: true },
      { id: "f6", label: "주요 라인업", type: "text", placeholder: "예: 루나&스타즈, DarkNova, M.O.N.G.", required: true },
      { id: "f7", label: "운영 계획 요약", type: "textarea", placeholder: "스테이지 구성, 비상 대응 계획, 보안 계획 등", required: true },
    ],
  },
  {
    id: "tmpl7",
    type: "budget",
    title: "보조금 신청 기안서",
    icon: "ri-government-line",
    description: "정부·기관 보조금 신청 내부 승인",
    fields: [
      { id: "f1", label: "지원 기관", type: "text", placeholder: "예: 한국문화예술위원회", required: true },
      { id: "f2", label: "사업명", type: "text", placeholder: "예: 예술창작지원사업", required: true },
      { id: "f3", label: "신청 금액 (만원)", type: "number", placeholder: "예: 15000", required: true },
      { id: "f4", label: "사업 기간 (시작)", type: "date", required: true },
      { id: "f5", label: "사업 기간 (종료)", type: "date", required: true },
      { id: "f6", label: "사업 목표 및 수혜자", type: "textarea", placeholder: "사업 목표, 예상 수혜자 수, 사업 내용 요약", required: true },
      { id: "f7", label: "기대 효과", type: "textarea", placeholder: "사업 수행으로 기대되는 사회적·문화적 효과", required: true },
    ],
  },
  {
    id: "tmpl8",
    type: "legal",
    title: "IP 라이선스 계약 검토 요청",
    icon: "ri-copyright-line",
    description: "IP 라이선싱 계약 체결 전 결재",
    fields: [
      { id: "f1", label: "작품명", type: "text", placeholder: "예: 어둠 속의 빛", required: true },
      { id: "f2", label: "라이선스 유형", type: "select", options: ["드라마 판권", "OTT 판권", "게임 IP", "굿즈 라이선싱", "해외 번역출판", "영화 판권"], required: true },
      { id: "f3", label: "협상 상대방", type: "text", placeholder: "예: Netflix Korea", required: true },
      { id: "f4", label: "계약 금액 (만원)", type: "number", placeholder: "예: 80000", required: true },
      { id: "f5", label: "사용 지역", type: "select", options: ["국내", "아시아", "글로벌", "일본", "북미"], required: true },
      { id: "f6", label: "계약 기간 (년)", type: "number", placeholder: "예: 3", required: true },
      { id: "f7", label: "주요 계약 조건 및 검토 요청 사항", type: "textarea", placeholder: "독점 여부, 2차 저작물 제작권, 해지 조건, 독소조항 등", required: true },
    ],
  },
  {
    id: "tmpl9",
    type: "budget",
    title: "캠페인 기획안 제출",
    icon: "ri-advertisement-line",
    description: "광고 캠페인 기획안 클라이언트 제출 전 내부 결재",
    fields: [
      { id: "f1", label: "캠페인명", type: "text", placeholder: "예: 하이트진로 여름 SNS 캠페인", required: true },
      { id: "f2", label: "클라이언트", type: "text", placeholder: "예: 하이트진로", required: true },
      { id: "f3", label: "총 예산 (만원)", type: "number", placeholder: "예: 5000", required: true },
      { id: "f4", label: "집행 채널", type: "text", placeholder: "예: 인스타그램, 틱톡, 유튜브 쇼츠", required: true },
      { id: "f5", label: "캠페인 목표 KPI", type: "text", placeholder: "예: 브랜드 친밀도 +15%, 해시태그 챌린지 참여 10만건", required: true },
      { id: "f6", label: "핵심 메시지", type: "text", placeholder: "예: #여름진로챌린지 — 청량한 여름의 시작", required: true },
      { id: "f7", label: "타겟 오디언스", type: "textarea", placeholder: "연령대, 관심사, 행동 특성 등", required: true },
      { id: "f8", label: "기획 방향 요약", type: "textarea", placeholder: "콘텐츠 유형, 인플루언서 전략, 바이럴 포인트 등", required: true },
    ],
  },
  {
    id: "tmpl10",
    type: "budget",
    title: "보도자료 배포 기안서",
    icon: "ri-newspaper-line",
    description: "언론사 배포 전 보도자료 내용 및 배포 전략 내부 결재",
    fields: [
      { id: "f1", label: "보도자료 제목 (헤드라인)", type: "text", placeholder: "예: 루나&스타즈, 1st EP 'Starlight' 4월 15일 공식 발매", required: true },
      { id: "f2", label: "발신처 및 배포 예정일", type: "text", placeholder: "예: K-ArtPEN 엔터테인먼트 | 2026.04.01", required: true },
      { id: "f3", label: "배포 대상 언론사", type: "text", placeholder: "예: 연합뉴스, 스포츠조선, 아이돌차트, 뮤직뱅크, 스타뉴스", required: true },
      { id: "f4", label: "리드 문장 (Lead)", type: "textarea", placeholder: "5W1H를 담은 첫 2~3문장. 기자가 이것만 읽어도 기사화 여부를 판단할 수 있어야 합니다.", required: true },
      { id: "f5", label: "보도자료 본문 요약", type: "textarea", placeholder: "발매 배경, 앨범 구성, 아티스트 코멘트 등 핵심 내용 2~3문단", required: true },
      { id: "f6", label: "공식 인용구 (Quote)", type: "textarea", placeholder: "대표 또는 담당자 공식 코멘트 (인용구 포함 시 기사화 확률 크게 상승)", required: false },
      { id: "f7", label: "담당자 연락처", type: "text", placeholder: "예: 마케팅팀 김소현 | press@karten.co.kr | 02-1234-5678", required: true },
    ],
  },
];

// approvalTemplates에 병합
approvalTemplates.push(...extraTemplates);

export const approvalHistory = [
  {
    id: "ap1",
    type: "contract",
    title: "루나&스타즈 전속 계약서",
    submittedBy: "A&R팀 이민준",
    submittedAt: "2026.03.25 14:30",
    status: "approved",
    aiComment: "✅ 계약 조건 검토 완료. 수익 배분율(회사 60% / 아티스트 40%), 계약금 2,000만원 모두 업계 표준 범위 내입니다. 전속 기간 2년은 적정 수준입니다. 승인 처리되었습니다.",
    amount: 20000000,
    reputationChange: +5,
    capitalChange: -20000,
  },
  {
    id: "ap2",
    type: "budget",
    title: "봄 시즌 싱글 마케팅 예산",
    submittedBy: "마케팅팀 김수연",
    submittedAt: "2026.03.24 10:15",
    status: "approved",
    aiComment: "✅ 예산 항목 적정성 검토 완료. SNS 광고비 500만원, 미디어 피처링 비용 300만원, 포토카드 제작 200만원 - 합계 1,000만원은 싱글 마케팅 기준 적정합니다.",
    amount: 10000000,
    reputationChange: 0,
    capitalChange: -10000,
  },
  {
    id: "ap3",
    type: "budget",
    title: "DarkNova MV 제작 예산",
    submittedBy: "제작팀 박준혁",
    submittedAt: "2026.03.26 16:45",
    status: "pending",
    aiComment: "🔍 검토 중. 총 8,000만원 예산 중 촬영 장비 렌탈 2,000만원, 감독비 3,000만원, 편집비 1,500만원, 기타 1,500만원. 감독비 비중이 다소 높습니다. 세부 견적서 보완 요청.",
    amount: 80000000,
    reputationChange: 0,
    capitalChange: 0,
  },
  {
    id: "ap4",
    type: "release",
    title: "루나&스타즈 1st EP 'Starlight' 발매 기안",
    submittedBy: "A&R팀 이민준",
    submittedAt: "2026.03.20 09:00",
    status: "rejected",
    aiComment: "❌ 반려. 앨범 콘셉트 요약란에 타깃 층 연령대가 명시되지 않았으며, 음원 유통 계약이 아직 완료되지 않은 상태입니다. 유통 계약 확정 후 재제출 바랍니다.",
    amount: 0,
    reputationChange: 0,
    capitalChange: 0,
  },
  {
    id: "ap5",
    type: "legal",
    title: "YoonArt Studio 저작권 분쟁 대응",
    submittedBy: "법무팀 최지영",
    submittedAt: "2026.03.22 13:20",
    status: "approved",
    aiComment: "✅ 승인. 합의 협상 방향으로 대응하는 것이 비용 및 리스크 측면에서 적절합니다. 법률 비용 예산 200만원 집행 승인.",
    amount: 2000000,
    reputationChange: 0,
    capitalChange: -2000,
  },
];
